import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  BasketFacade,
  calculateSelectedQuotesTotalPayment,
  QuoteDetails,
} from '@domgen/dgx-fe-basket';
import { filterNullUndefined, PaymentType } from '@domgen/dgx-fe-common';
import { FormOption } from '@domgen/dgx-fe-forms/shared';
import { TranslateService } from '@domgen/dgx-fe-i18n';
import {
  FeaturePaymentMethodTranslationDictionary,
  PaymentMethodForm,
} from '@checkout/util-models';
import { combineLatest, map, Observable } from 'rxjs';
import { PaymentMethodFormBuilderService } from '../payment-method-form-builder/payment-method-form-builder.service';

export type PaymentMethodOptions = {
  card: FormOption<PaymentType>;
  directDebit: FormOption<PaymentType>;
};

export interface ViewModel {
  selectedQuotesTotalPayment: number;
  selectedQuotesTotalCardPayment: number;
  selectedQuotesTotalDirectDebitPayment: number;
}

@Injectable()
export class PaymentMethodFormComponentService {
  form: FormGroup<PaymentMethodForm>;
  paymentMethodOptions: PaymentMethodOptions;
  selectedQuotesTotalPayment$ =
    this.basketFacade.selectedQuotesTotalPayment$.pipe(filterNullUndefined());
  selectedQuotesTotalCardPayment$ = this.basketFacade.selectedQuotes$.pipe(
    map((quotes: QuoteDetails[]) =>
      calculateSelectedQuotesTotalPayment(quotes, PaymentType.Card)
    )
  );
  selectedQuotesTotalDirectDebitPayment$ =
    this.basketFacade.selectedQuotes$.pipe(
      map((quotes: QuoteDetails[]) =>
        calculateSelectedQuotesTotalPayment(quotes, PaymentType.DirectDebit)
      )
    );

  constructor(
    private readonly basketFacade: BasketFacade,
    private readonly paymentMethodFormBuilderService: PaymentMethodFormBuilderService,
    private readonly translateService: TranslateService<FeaturePaymentMethodTranslationDictionary>
  ) {
    this.form = paymentMethodFormBuilderService.build();
    this.paymentMethodOptions = {
      card: {
        value: PaymentType.Card,
        label: translateService.translate(
          'PAYMENT_METHOD_CREDIT_CARD_OPTION_LABEL'
        ),
      },
      directDebit: {
        value: PaymentType.DirectDebit,
        label: translateService.translate(
          'PAYMENT_METHOD_DIRECT_DEBIT_OPTION_LABEL'
        ),
      },
    };
  }

  readonly vm$: Observable<ViewModel> = combineLatest({
    selectedQuotesTotalPayment: this.selectedQuotesTotalPayment$,
    selectedQuotesTotalCardPayment: this.selectedQuotesTotalCardPayment$,
    selectedQuotesTotalDirectDebitPayment:
      this.selectedQuotesTotalDirectDebitPayment$,
  });
}
